<script>
    export let text = "";
    export let onClick = () => {};
    export let isEnabled = true;
    export let secondary = false;

    let currentText = text;
    let resetTimeout;

    export function showTemporaryText(tempText, duration = 3000) {
      clearTimeout(resetTimeout);
      currentText = tempText;
      resetTimeout = setTimeout(() => {
        currentText = text;
      }, duration);
    }
  </script>
  
  <button
    class=" px-4 py-2 rounded-lg border self-end"
    class:bg-[var(--app-primary-error-color)]={isEnabled && !secondary}
    class:border-[var(--app-primary-error-color)]={isEnabled}
    class:border-[var(--app-alt-color)]={!isEnabled}
    class:hover:border-[var(--app-primary-error-color)]={isEnabled}
    class:text-white={isEnabled}
    class:hover:bg-[var(--app-primary-error-color-darker)]={isEnabled}
    class:bg-transparent={!isEnabled}
    class:text-gray-500={!isEnabled}
    class:cursor-not-allowed={!isEnabled}
    on:click={onClick}
    disabled={!isEnabled}
  >
    {currentText}
  </button>
  